export const GET_CHARTING_SCREEN_SHOT = 'GET_CHARTING_SCREEN_SHOT';
export const CHARTING_SCREEN_SHOT_READY = 'CHARTING_SCREEN_SHOT_READY';
export const SESSION_TIME_OUT = 'SESSION_TIME_OUT';
export const API_TIMEOUT = 'ECONNABORTED ';
export const LOAD_WORKSPACE = 'LOAD_WORKSPACE';
export const SET_ERROR = 'SET_ERROR';

export const SYNC_COMPONENT_SEARCH = 'SYNC_COMPONENT_SEARCH';
export const SYNC_COMPONENT_LINK_BUY_SELL = 'SYNC_COMPONENT_LINK_BUY_SELL';
export const TICKER_ADDED_TO_WL = 'TICKER_ADDED_TO_WL';
export const SHOULD_CALC_SIZE = 'SHOULD_CALC_SIZE';

export const SHOW_GUEST_POPUP = 'SHOW_GUEST_POPUP';

export const ON_TAB_FOCUS_BLUR = 'ON_TAB_FOCUS_BLUR';
export const TRADING_VIEW_WIDGET_RESET_DATA = 'TRADING_VIEW_WIDGET_RESET_DATA';
export const TRADING_VIEW_WRAPPER_DATA = 'TRADING_VIEW_WRAPPER_DATA';
export const TRADING_VIEW_WRAPPER_DATA_LOADING =
  'TRADING_VIEW_WRAPPER_DATA_LOADING';
export const TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL =
  'TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL';
export const TRADING_VIEW_WRAPPER_DATA_RESOLUTION =
  'TRADING_VIEW_WRAPPER_DATA_RESOLUTION';
export const TRADING_VIEW_WRAPPER_DATA_RESET =
  'TRADING_VIEW_WRAPPER_DATA_RESET';
export const TRADING_VIEW_WRAPPER_DATA_IS_MAIN_SYMBOL_RETURN_NULL =
  'TRADING_VIEW_WRAPPER_DATA_IS_MAIN_SYMBOL_RETURN_NULL';

class EventEmitter {
  events = {};

  dispatch = (event, data) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].forEach(callback => {
      callback(data);
    });
  };

  subscribe = (event, callback) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  };

  unsubscribe = (event, callback) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event] = this.events[event].filter(func => func !== callback);
  };
}

export default new EventEmitter();
